/* eslint-disable */
// WARNING: This module is deprecated. Do not add here any new constants. Use `modal/state/constants`
export const MODULE_NAME = 'modal';
export const PARAM_NAME = 'modal';
export const BODY_OPEN_CLASS = 'ggModalOpen';
export const HTML_OPEN_CLASS = 'ggModalOpen';
export * from './propTypes';
